<div class="d-flex flex-column align-items-start">
  
  @if(crmService.wizardLoading().isLoadingWizardStep){
    <zint-loader class="mx-auto" size="small"></zint-loader>
  }
  @if (crmService.wizardLoading().isLoadingWizardStepAction) {
    <zint-loader size="small" [overlay]="true" [dotColor]="'var(--zint-grey-500)'"></zint-loader>
  }  
  
  <input type="text" class="rounded-input-base full-width mb-2" placeholder="search for a CRM object" [formControl]="objectSearchControl"/>
  @for (item of filteredCRMObjects$ | async; track $index) {
    <label class="zint-base-card d-flex justify-content-between w-100" [ngClass]="{'border-primary': selectedObjectType?.name === item.name}" [for]="'radio-' + $index">
      <span><i [ngClass]="renderCRMObjectIcons(item.name)" class="mr-2"></i>{{ item.label | titlecase }} {{item.recommended ? '(Recommended)': ''}}</span>
        <input type="radio" [id]="'radio-' + $index" name="objectType" 
          [value]="item"
          [disabled]="crmService.wizardLoading().isLoadingWizardStepAction" 
          [checked]="selectedObjectType?.name === item.name"         
          (click)="confirmObjectTypeChange(item)" /> 
    </label> 
  } @empty {
      <span>
        <i class="fal fa-magnifying-glass-minus mr-1"></i>
        No match found
      </span>   
    }
</div>
@if (showConfirmModal) {
<div class="modal fade" id="confirmObjectTypeChange" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Existing Selection!</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="mark">Changing CRM object selection will delete and reset the subsequent configurations in the steps following!</p>
        <button class="rounded-btn-base rounded-btn-orange btn-p-md float-right" (click)="postChoiceAndGetStatus()">Confirm</button>
      </div>
    </div>
  </div>
</div>
}